export function timeLogActionLabel(action) {
    switch (action) {
        case "startShift":
            return "Schichtbeginn";
        case "endShift":
            return "Schichtende";
        case "startBreak":
            return "Beginn Pause";
        case "endBreak":
            return "Ende Pause";
    }
}
export function timeLogActionIcon(action) {
    switch (action) {
        case "startShift":
            return "icon.action.start-shift";
        case "endShift":
            return "icon.action.end-shift";
        case "startBreak":
        case "endBreak":
            return "icon.object.break";
    }
}
export function timeLogEventSourceLabel(type) {
    switch (type) {
        case "employee_app":
            return "Mitarbeiter-App";
        case "external":
            return "Extern";
        case "terminal":
            return "Stempeluhr";
    }
}
export function timeLogEventSourceIcon(type) {
    switch (type) {
        case "employee_app":
            return "icon.object.mobile-app";
        case "external":
            return "icon.object.api-source";
        case "terminal":
            return "icon.feature.time-tracking";
    }
}
//# sourceMappingURL=time-log.util.js.map